// Durable client-side storage. The whole library (documents, embeddings,
// conversations) lives in IndexedDB, so eviction = data loss. Browsers may evict
// "best-effort" storage under disk pressure, and Safari/WebKit (ITP) clears it
// after ~7 days without a site visit. Requesting persistent storage opts out.
//
// persist() is silent in Chrome (granted by heuristics), may prompt in Firefox,
// and is unsupported on older Safari — hence the capability guard and the
// supported/persisted split so the UI can be honest about durability.

export interface StorageDurability {
  /** navigator.storage.persist is available in this browser. */
  supported: boolean;
  /** Storage is persistent — won't be auto-evicted. */
  persisted: boolean;
}

export async function ensurePersistentStorage(): Promise<StorageDurability> {
  if (!navigator.storage?.persist || !navigator.storage?.persisted) {
    return { supported: false, persisted: false };
  }
  try {
    let persisted = await navigator.storage.persisted();
    if (!persisted) {
      persisted = await navigator.storage.persist();
    }
    return { supported: true, persisted };
  } catch {
    return { supported: false, persisted: false };
  }
}
